<template>
  <div class="homePage">
    <div class="big_her">
      <div class="herder">
        <div>
          <button @click="$router.push('/login')">点击登录</button>
          <button @click="$router.push('/Register')">立即注册</button>
        </div>
      </div>
    </div>
    <div class="big_content">
      <div class="content">
        <h4>在线论文投稿条款</h4>
        <span />
        <h3>第十六届全国治疗药物监测学术年会</h3>
        <p class="p40">各位药师:</p>
        <p class="p1193">
          执诚欢迎您参加第十六届全国治疗药物监测学术年会的诊文投稿!本次论坛采用在线方式进行投稿及评审工作，为帮助您顺利完成投稿，请您仔细阅读以
          下说明，并按照说明进行投稿：
        </p>
        <p class="p1193">
          本次大会论文投稿的征文内容包括:
        </p>
        <p class="pt7">
          (一)征文日期:2021年8月29日24:00前投稿可参与优秀论文评选；
        </p>

        <p class="p1193">
          (二)征文内容:以个体化药物治疗为核心的TDM理论。方法，应用研究及实践经验:TDM创新思维、政策、教育、管理等:TDM相关学科，如定量药理、循
          证药学药品风险管理研究和认知等；
        </p>
        <p class="pt20">
          (三)投稿要求:来稿须注明作者、单位及联系方式，文本请以word格式上传。每篇摘要不少于500字(论文摘要样式详见附件):
        </p>
        <p class="p1193">
          (四)投稿方式:线上投稿，请登陆TDM专委会网站，点击"第十六届全国治疗药物监测学术年会”鞋接，在首页完成"会议注册”后，点击“会议投稿”提
          交稿件。
        </p>

        <p class="p1193">
          (五)征文评选:大会主办方组织专家对征文进行综合评价，评选出的优秀论文将在"第十六届全国治疗药物监测学术年会”上进行交流。
        </p>
        <p class="pt20">
          联系人与联系方式：
        </p>
        <p class="pt20">
          陈文倩 电话:15801454636
        </p>
        <button @click="$router.push('/login')">
          我已阅读并接受此协议，开始投稿
        </button>
      </div>
    </div>

    <div class="login_ftrr">
      <p>Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  },
  components: {},
  methods: {
    submitForm(formName) {}
  }
}
</script>
<style lang="less" scoped>
.homePage {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .login_ftrr {
    margin-top: 20px;
    padding-left: 360px;
    height: 39px;
    line-height: 2;
    font-family: 'SourceHanSansCN-Regular';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #aaaaaa;
  }
  .pt20 {
    padding-top: 20px;
  }
  .pt7 {
    padding-top: 7px;
  }
  .p1193 {
    width: 1193px;
    line-height: 2;
    padding-top: 30px;
  }
  .big_content {
    background-color: #f6fbff;
    padding-top: 92px;
    padding-bottom: 82px;
    box-sizing: border-box;
  }
  .content {
    margin: 0 auto;
    width: 1200px;
    // height: 1182px;
    button {
      // margin: 0 auto;
      margin: 64px auto 0;
      width: 350px;
      height: 50px;
      background-color: #00599e;
      border-radius: 5px;
      border: 0;
      display: block;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
    }
    .p40 {
      margin-top: 40px;
    }
    h3 {
      text-align: center;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0px;
      letter-spacing: 0px;
      color: #00599e;
    }
    h4 {
      text-align: center;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
      margin-bottom: 29px;
    }
    span {
      display: block;
      width: 1200px;
      height: 2px;
      background-color: #c7ddeb;
      margin-bottom: 58px;
    }
  }
  .big_her {
    background: #fff;
    width: 100%;
  }
  .herder {
    height: 100px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 360px;
    div {
      display: flex;
      width: 270px;
      justify-content: space-between;
      align-items: center;

      button {
        width: 130px;
        height: 50px;
        background-color: #00599e;
        border-radius: 5px;
        border: 0;
        color: #fff;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0px;
        letter-spacing: 0px;
      }
    }
  }
}
</style>
